/**
 * Quita pictogramas emoji del texto (p. ej. mensajes del orquestador / i18n legacy).
 * No elimina todos los símbolos Unicode; solo Extended_Pictographic + FE0F.
 */
export function stripEmojiUnicode(text: string): string {
  if (!text) return text;
  return text
    .replace(/\p{Extended_Pictographic}/gu, '')
    .replace(/\uFE0F/g, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
}
